// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","footerWrapper":"App_footerWrapper__3pf8k","footer":"App_footer__29Fsv","main":"App_main__3ZkGI","image":"App_image__3byI1"};